import React, { useState } from 'react';

import Icon from '../components/Icon';

export default function PasswordInput({ ...inputProps }) {
  const [showPassword, setShowPassword] = useState(false);
  const eyeIcon = showPassword ? 'fetch-eye-close' : 'fetch-eye-open';

  return (
    <div className="flex justify-between bg-white b--default ba br3 ph4 w-100">
      <input
        className="DSInput pv3 bw0 input-reset font-16 w-100"
        type={showPassword ? 'text' : 'password'}
        {...inputProps}
      />
      <button
        type="button"
        onClick={e => {
          e.preventDefault();
          setShowPassword(!showPassword);
        }}
      >
        <Icon className="secondary" name={eyeIcon} />
      </button>
    </div>
  );
}
